import React, { Component } from 'react'
import { connect } from 'react-redux'
import clients from 'redux/clients'
import Donation from './Donation'
import PropTypes from 'prop-types'
import { push } from 'connected-react-router'
import moment from 'moment'
import yn from 'yn'
class DonationContainer extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isloading: true,
      serviceId: '',
      isLoadingChangeAccountType: false,
      vendorId: 0,
      accountType: [],
      barCode: '',
      documentNumber: props.cpf ? props.cpf.value : '',
      data: '',
      billValue: 0,
      pointsValue: 0,
      isPriceEditable: false,
      name: '',
      errorPage: null,
      error: null,
      successPage: null,
      errorField: null,
      showTerms: false,
      acceptTerms: false,
      sendRedemptionError: props.sendRedemptionError,
      institutions: [],
      donationPointsValue: 0,
      convertedValue: 0,
      imageUrl: '',
      validateConversion: false
    }

    this.handlerChangeAccountType = this.handlerChangeAccountType.bind(this)
    this.handlerGetBarCode = this.handlerGetBarCode.bind(this)
    this.handlerGetData = this.handlerGetData.bind(this)
    this.handlerCloseError = this.handlerCloseError.bind(this)
    this.handlerCloseSuccess = this.handlerCloseSuccess.bind(this)
    this.handlerFinalizePayment = this.handlerFinalizePayment.bind(this)
    this.handlerAccountTypes = this.handlerAccountTypes.bind(this)
    this.institutions = this.handlerListInstitutions.bind(this)
    this.closeterms = this.closeterms.bind(this)
    this.acceptTermsEvent = this.acceptTermsEvent.bind(this)
    this.showTermsEvent = this.showTermsEvent.bind(this)
    this.handlerServiceId = this.handlerServiceId.bind(this)
    this.handlerDonatedPoints = this.handlerDonatedPoints.bind(this)
    this.handlerConvertionPointsToCash = this.handlerConvertionPointsToCash.bind(
      this
    )
    this.handlerFinalizeDonation = this.handlerFinalizeDonation.bind(this)
  }
  count = 0
  client
  componentDidMount () {
    if (this.count === 0) {
      this.count++
      const {
        cloudloyalty: { client }
      } = clients

      this.client = client
      this.handlerAccountTypes()
      this.handlerListInstitutions()
    }
  }

  acceptTermsEvent () {
    if (this.state.acceptTerms) {
      this.setState({
        showTerms: false,
        acceptTerms: false
      })
    } else {
      this.setState({
        showTerms: false,
        acceptTerms: true
      })
    }
  }

  showTermsEvent () {
    this.setState({
      showTerms: true
    })
  }

  closeterms () {
    this.setState({ showTerms: false })
  }

  handlerGetBarCode (e) {
    this.setState({ barCode: e.target.value && e.target.value.trim() })
  }

  handlerGetData (e) {
    this.setState({ data: e.target.value })
  }

  handlerDonatedPoints (e) {
    this.setState({ donationPointsValue: e })
  }

  handlerServiceId (e) {
    this.setState({ serviceId: e.serviceId })
    this.setState({ vendorId: e.value })
    this.setState({ imageUrl: e.imageUrl })
  }

  handlerConvertionPointsToCash (e) {
    e <= 0
      ? this.setState({ validateConversion: false })
      : this.setState({ validateConversion: true })
    const modelToConvert = {
      vendorId: this.state.vendorId,
      serviceId: this.state.serviceId,
      pointsValue: e
    }
    this.setState({ donationPointsValue: e })

    this.client
      .put(`/v1/donation/`, modelToConvert)
      .then(response => {
        this.setState({ convertedValue: response.data.cashValue })
      })
      .catch(this.setState({ convertedValue: 0 }))
  }

  handlerChangeAccountType (e) {
    const serviceId = e.value

    this.setState({ isLoadingChangeAccountType: true })

    this.client
      .get(
        `/v1/billPayments/vendor/${this.state.vendorId}/service/${serviceId}/validate/${this.state.barCode}`
      )
      .then(result => {
        this.setState({
          ...result.data,
          errorField: null,
          serviceId: e.value,
          isLoadingChangeAccountType: false
        })
      })
      .catch(ex => this.ExceptionChangeAccountType(ex))
  }

  ExceptionChangeAccountType (ex) {
    const {
      response: { data }
    } = ex

    if (data.errors[0].code === 11) {
      this.setState({
        errorField: false,
        billValue: 0,
        pointsValue: 0.0,
        isPriceEditable: true,
        name: '',
        isloading: false,
        isLoadingChangeAccountType: false
      })
    }
  }

  handlerListInstitutions () {
    this.setState({ loadingPayment: false })

    this.client
      .get(`/v1/donation`)
      .then(result => {
        this.setState({ isloading: false, institutions: result.data })
      })
      .catch(ex => console.error(ex))
  }

  handlerFinalizePayment () {
    if (!this.state.acceptTerms) {
      return this.handlerShowErrorPage(
        'Regulamento',
        'Favor aceitar o Regulamento!'
      )
    }

    const payment = {
      serviceId: this.state.serviceId,
      barCode: this.state.barCode,
      dueDate: moment(this.state.data, 'DD/MM/YYYY').format('MM/DD/YYYY'),
      documentNumber: this.state.documentNumber,
      billValue: this.state.billValue
    }

    this.setState({ loadingPayment: true })

    this.client
      .post('/v1/purchases/billPayment', payment)
      .then(response => {
        this.setState({
          loadingPayment: false,
          successPage: {
            title: 'Pagamento!',
            description: 'Seu pagamento foi realizado com sucesso!'
          },
          serviceId: '',
          barCode: '',
          data: '',
          billValue: '',
          pointsValue: '',
          name: ''
        })

        const {
          data: { id }
        } = response

        this.props.redirectConfirmation(`/confirmation/${id}`)
      })
      .catch(ex => this.ExceptionFinalizePayment(ex))
  }

  ExceptionFinalizePayment (ex) {
    const {
      response: { data }
    } = ex

    this.setState({
      loadingPayment: false
    })

    const message = data
      ? data.errors[0].message.replace(
        'DueDate inválido',
        'Data de vencimento inválida'
      )
      : data

    this.handlerShowErrorPage(
      'Erro ao tentar efetuar o pagamento!',
      data ? message : 'problemas técnicos'
    )
  }

  handlerCloseError () {
    this.setState({ sendRedemptionError: null })
  }

  handlerCloseSuccess () {
    this.setState({ successPage: null })
  }

  handlerShowErrorPage (title, description) {
    this.setState({
      errorPage: {
        title: title,
        description: description,
        closeError: () => this.handlerCloseError()
      }
    })
  }

  handlerAccountTypes () {
    this.client
      .get(`/v1/billPayments/vendor/${this.state.vendorId}/service`)
      .then(result => {
        this.setState({ isloading: false, accountType: result.data })
      })
      .catch(() =>
        this.handlerShowErrorPage(
          '! tipos de contas',
          'erro ao tentar obter os tipos de contas'
        )
      )
  }

  handlerFinalizeDonation () {
    this.setState({ loadingPayment: true })

    var model = {
      vendorId: this.state.vendorId,
      serviceId: this.state.serviceId,
      costPrice: this.state.convertedValue,
      type: 3,
      configuration: []
    }
    model.configuration.push({
      key: 'AcceptRegulation',
      value: !yn(process.env.REACT_APP_HAS_OPTIN_REGULATION) || this.state.acceptTerms ? 'true' : 'false'
    })

    this.client.post('/v1/purchases/service', model).then(({ data }) => {
      this.setState({ loadingPayment: false })

      this.props.redirectConfirmation({
        pathname: `/confirmation/${data.id}`
      })
    })
  }

  render () {
    return (
      <Donation
        {...this.state}
        handlerServiceId={this.handlerServiceId}
        handlerFinalizeDonation={this.handlerFinalizeDonation}
        handlerDonatedPoints={this.handlerDonatedPoints}
        handlerConvertionPointsToCash={this.handlerConvertionPointsToCash}
        handlerChangeAccountType={this.handlerChangeAccountType}
        handlerFinalizePayment={this.handlerFinalizePayment}
        handlerGetBarCode={this.handlerGetBarCode}
        handlerGetData={this.handlerGetData}
        handlerCloseError={this.handlerCloseError}
        handlerCloseSuccess={this.handlerCloseSuccess}
        handlerListInstitutions={this.handlerListInstitutions}
        acceptTermsEvent={this.acceptTermsEvent}
        closeterms={this.closeterms}
        showTermsEvent={this.showTermsEvent}
        participantPoints={this.props.pointsValue}
      />
    )
  }
}

const mapStateToProps = ({
  participant: { cpf },
  oidc,
  fuelCredit,
  balance
}) => {
  const { user } = oidc
  const { profile } = user || {}
  return {
    cpf: cpf,
    catalogId: (!profile ? null : profile['custom:catalog_id']),
    pointsValue: balance.pointsValue,
    ...fuelCredit
  }
}

const mapDispatchToProps = dispatch => ({
  redirectConfirmation: path => dispatch(push(path))
})

DonationContainer.propTypes = {
  cpf: PropTypes.object,
  redirectConfirmation: PropTypes.func,
  sendRedemptionError: PropTypes.bool,
  pointsValue: PropTypes.number,
  loggedUser: PropTypes.bool
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DonationContainer)



// WEBPACK FOOTER //
// ./src/features/Donation/DonationContainer.js